import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-175fc3d6"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["href"]
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  href: "./contact_us",
  role: "menuitem"
}, "Contact", -1))
const _hoisted_3 = { class: "row flex-around-menu" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-sm-6" }, [
  /*#__PURE__*/_createElementVNode("img", {
    alt: "AVA Pharmacy Online Shop",
    src: "images/logo.png",
    style: {"max-width":"130px"}
  })
], -1))
const _hoisted_5 = { class: "col-sm-6 flex-item" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "loder" }, null, -1))
const _hoisted_7 = { class: "wrapper" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  id: "subscribe-me",
  class: "modal animated fade in",
  role: "dialog",
  "data-keyboard": "true",
  tabindex: "-1"
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "newsletter-popup" }, [
    /*#__PURE__*/_createElementVNode("img", {
      class: "offer",
      src: "images/newsbg.jpg",
      alt: "offer"
    }),
    /*#__PURE__*/_createElementVNode("div", { class: "newsletter-popup-static newsletter-popup-top" }, [
      /*#__PURE__*/_createElementVNode("div", { class: "popup-text" }, [
        /*#__PURE__*/_createElementVNode("div", { class: "popup-title" }, [
          /*#__PURE__*/_createTextVNode("50% "),
          /*#__PURE__*/_createElementVNode("span", null, "off")
        ]),
        /*#__PURE__*/_createElementVNode("div", { class: "popup-desc" }, [
          /*#__PURE__*/_createElementVNode("div", null, "Sign up and get 50% off your next Order")
        ])
      ]),
      /*#__PURE__*/_createElementVNode("form", {
        onsubmit: "return  validatpopupemail();",
        method: "post"
      }, [
        /*#__PURE__*/_createElementVNode("div", { class: "form-group required" }, [
          /*#__PURE__*/_createElementVNode("input", {
            type: "email",
            name: "email-popup",
            id: "email-popup",
            placeholder: "Enter Your Email",
            class: "form-control form-control-lg",
            required: ""
          }),
          /*#__PURE__*/_createElementVNode("button", {
            type: "submit",
            class: "btn btn-secondary btn-lg",
            id: "email-popup-submit"
          }, "Subscribe"),
          /*#__PURE__*/_createElementVNode("label", { class: "checkme" }, [
            /*#__PURE__*/_createElementVNode("input", {
              type: "checkbox",
              value: "",
              id: "checkme"
            }),
            /*#__PURE__*/_createTextVNode("Dont show again")
          ])
        ])
      ])
    ])
  ])
], -1))
const _hoisted_9 = {
  id: "header",
  class: "desktop-view"
}
const _hoisted_10 = { class: "header-top" }
const _hoisted_11 = { class: "container" }
const _hoisted_12 = { class: "row" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-sm-6" }, null, -1))
const _hoisted_14 = { class: "col-sm-6" }
const _hoisted_15 = { class: "header-top-right text-right" }
const _hoisted_16 = {
  key: 0,
  class: "account"
}
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", { href: "login" }, "Login", -1))
const _hoisted_18 = [
  _hoisted_17
]
const _hoisted_19 = {
  key: 1,
  class: "account"
}
const _hoisted_20 = { href: "account" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", { class: "cart" }, [
  /*#__PURE__*/_createElementVNode("a", { href: "cart" }, "My Cart")
], -1))
const _hoisted_22 = { class: "header" }
const _hoisted_23 = { class: "container" }
const _hoisted_24 = { class: "navbar navbar-expand-lg navbalight bglight" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "navbar-header mtb_20" }, [
  /*#__PURE__*/_createElementVNode("a", {
    class: "navbar-brand",
    href: "/"
  }, [
    /*#__PURE__*/_createElementVNode("img", {
      alt: "AVA Pharmacy Online",
      src: "images/logo.png",
      style: {"max-width":"150px","margin-top":"-7px"}
    })
  ])
], -1))
const _hoisted_26 = { class: "collapse navbar-collapse js-navbar-collapse pull-right" }
const _hoisted_27 = {
  id: "menu",
  class: "navbar-nav ml-auto flex"
}
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", { class: "nav-item px-4" }, [
  /*#__PURE__*/_createElementVNode("a", { href: "/" }, "Home")
], -1))
const _hoisted_29 = { class: "nav-item dropdown mega-dropdown" }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  class: "nav-link dropdown-toggle",
  href: "#",
  id: "collectionsDropdown",
  role: "button",
  "data-toggle": "dropdown",
  "aria-haspopup": "true",
  "aria-expanded": "false"
}, "Collections", -1))
const _hoisted_31 = {
  class: "dropdown-menu dropdown-menu-right mega-dropdown-menu",
  "aria-labelledby": "collectionsDropdown"
}
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", { class: "dropdown-item" }, "Collections", -1))
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", { class: "dropdown-item" }, "Best Selected Categories", -1))
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "dropdown-divider" }, null, -1))
const _hoisted_35 = { class: "d-md-flex align-items-start justify-content-start" }
const _hoisted_36 = { class: "dropdown-header" }
const _hoisted_37 = ["href", "title"]
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "dropdown-divider" }, null, -1))
const _hoisted_39 = { class: "d-md-flex align-items-start justify-content-start" }
const _hoisted_40 = { class: "dropdown-header" }
const _hoisted_41 = ["href", "title"]
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "dropdown-divider" }, null, -1))
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  class: "dropdown-item",
  href: "/categories"
}, "All Collections", -1))
const _hoisted_44 = { class: "nav-item dropdown mega-dropdown" }
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  class: "nav-link dropdown-toggle",
  href: "#",
  id: "brandsDropdown",
  role: "button",
  "data-toggle": "dropdown",
  "aria-haspopup": "true",
  "aria-expanded": "false"
}, "Brands", -1))
const _hoisted_46 = {
  class: "dropdown-menu dropdown-menu-right",
  "aria-labelledby": "brandsDropdown"
}
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", { class: "dropdown-item" }, "Brands", -1))
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", { class: "dropdown-item" }, "Selected Brands", -1))
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "dropdown-divider" }, null, -1))
const _hoisted_50 = { class: "d-md-flex align-items-start justify-content-start" }
const _hoisted_51 = { class: "dropdown-header" }
const _hoisted_52 = ["href", "title"]
const _hoisted_53 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "dropdown-divider" }, null, -1))
const _hoisted_54 = { class: "d-md-flex align-items-start justify-content-start" }
const _hoisted_55 = { class: "dropdown-header" }
const _hoisted_56 = ["href", "title"]
const _hoisted_57 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "dropdown-divider" }, null, -1))
const _hoisted_58 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  class: "dropdown-item",
  href: "/brands"
}, "All Brands", -1))
const _hoisted_59 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", { class: "nav-item dropdown" }, [
  /*#__PURE__*/_createElementVNode("a", {
    class: "nav-link dropdown-toggle",
    href: "#",
    id: "quickLinksDropdown",
    role: "button",
    "data-toggle": "dropdown",
    "aria-haspopup": "true",
    "aria-expanded": "false"
  }, "More..."),
  /*#__PURE__*/_createElementVNode("div", {
    class: "dropdown-menu dropdown-menu-right",
    "aria-labelledby": "quickLinksDropdown"
  }, [
    /*#__PURE__*/_createElementVNode("a", {
      class: "dropdown-item",
      href: "contact_us"
    }, "Contact us"),
    /*#__PURE__*/_createElementVNode("a", {
      class: "dropdown-item",
      href: "cart"
    }, "Cart"),
    /*#__PURE__*/_createElementVNode("a", {
      class: "dropdown-item",
      href: "checkout"
    }, "Checkout")
  ])
], -1))
const _hoisted_60 = { class: "nav-item px-4" }
const _hoisted_61 = { href: "prescription" }
const _hoisted_62 = /*#__PURE__*/_createTextVNode(" Upload Prescription ")
const _hoisted_63 = { class: "header-right float-right mtb_50" }
const _hoisted_64 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  class: "navbar-toggler float-left",
  type: "button",
  "data-toggle": "collapse",
  "data-target": ".js-navbar-collapse"
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "i-bar" }, [
    /*#__PURE__*/_createElementVNode("i", { class: "fa fa-bars" })
  ])
], -1))
const _hoisted_65 = { class: "shopping-icon" }
const _hoisted_66 = {
  class: "badge badge-pill badge-danger",
  "data-target": "#cart-dropdown",
  "data-toggle": "collapse",
  "aria-expanded": "true",
  role: "button"
}
const _hoisted_67 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa fa-shopping-cart mr-2" }, null, -1))
const _hoisted_68 = {
  id: "cart-dropdown",
  class: "cart-menu collapse"
}
const _hoisted_69 = { key: 0 }
const _hoisted_70 = { class: "table" }
const _hoisted_71 = { class: "text-center" }
const _hoisted_72 = ["href"]
const _hoisted_73 = ["src", "alt", "title"]
const _hoisted_74 = { class: "text-left product-name" }
const _hoisted_75 = { href: "#" }
const _hoisted_76 = { class: "text-left price" }
const _hoisted_77 = { class: "input-group mb-3 btn-block" }
const _hoisted_78 = { class: "input-group-prepend" }
const _hoisted_79 = ["onClick"]
const _hoisted_80 = ["value", "onChange"]
const _hoisted_81 = { class: "input-group-append" }
const _hoisted_82 = ["onClick"]
const _hoisted_83 = { class: "text-center" }
const _hoisted_84 = ["onClick"]
const _hoisted_85 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa fa-times-circle" }, null, -1))
const _hoisted_86 = [
  _hoisted_85
]
const _hoisted_87 = { class: "table" }
const _hoisted_88 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "text-right" }, [
  /*#__PURE__*/_createElementVNode("strong", null, "Sub-Total")
], -1))
const _hoisted_89 = { class: "text-right" }
const _hoisted_90 = { class: "text-right" }
const _hoisted_91 = { class: "text-right" }
const _hoisted_92 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "text-right" }, [
  /*#__PURE__*/_createElementVNode("strong", null, "Total")
], -1))
const _hoisted_93 = { class: "text-right" }
const _hoisted_94 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", null, [
  /*#__PURE__*/_createElementVNode("form", { action: "cart" }, [
    /*#__PURE__*/_createElementVNode("input", {
      class: "btn float-left mt_10",
      value: "View cart",
      type: "submit"
    })
  ]),
  /*#__PURE__*/_createElementVNode("form", { action: "checkout" }, [
    /*#__PURE__*/_createElementVNode("input", {
      class: "btn float-right mt_10",
      value: "Checkout",
      type: "submit"
    })
  ])
], -1))
const _hoisted_95 = { class: "main-search float-right" }
const _hoisted_96 = { class: "search-overlay" }
const _hoisted_97 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "container" }, [
  /*#__PURE__*/_createElementVNode("form", {
    role: "search",
    id: "searchform",
    action: "/search",
    method: "get"
  }, [
    /*#__PURE__*/_createElementVNode("label", {
      class: "h5 normal search-input-label",
      for: "searchinput",
      style: {"color":"aliceblue"}
    }, "Enter keywords To Search Entire Store"),
    /*#__PURE__*/_createElementVNode("input", {
      value: "",
      name: "term",
      placeholder: "Search here...",
      type: "search",
      id: "searchinput"
    }),
    /*#__PURE__*/_createElementVNode("button", { type: "submit" })
  ])
], -1))
const _hoisted_98 = { class: "header-search" }
const _hoisted_99 = { class: "header-bottom" }
const _hoisted_100 = { class: "container" }
const _hoisted_101 = { class: "row" }
const _hoisted_102 = { class: "col-sm-4 col-md-4 col-lg-3" }
const _hoisted_103 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "category" }, [
  /*#__PURE__*/_createElementVNode("div", {
    class: "menu-bar",
    "data-target": "#category-menu,#category-menu-responsive",
    "data-toggle": "collapse",
    "aria-expanded": "true",
    role: "button"
  }, [
    /*#__PURE__*/_createElementVNode("h4", { class: "category_text" }, "Top categories"),
    /*#__PURE__*/_createElementVNode("span", { class: "i-bar" }, [
      /*#__PURE__*/_createElementVNode("i", { class: "fa fa-bars" })
    ])
  ])
], -1))
const _hoisted_104 = {
  id: "category-menu-responsive",
  class: "accordion-collapse collapse",
  "data-bs-parent": "#myAccordion"
}
const _hoisted_105 = { class: "main-navigation collapse in" }
const _hoisted_106 = ["href"]
const _hoisted_107 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", null, [
  /*#__PURE__*/_createElementVNode("a", {
    class: "nav-link",
    href: "/brands"
  }, "Top Brands")
], -1))
const _hoisted_108 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "navresponsive" }, null, -1))
const _hoisted_109 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-sm-8 col-md-8 col-lg-9" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "header-bottom-right offers" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "marquee" }, [
      /*#__PURE__*/_createElementVNode("span", null, [
        /*#__PURE__*/_createElementVNode("i", {
          class: "fa fa-circle",
          "aria-hidden": "true"
        }),
        /*#__PURE__*/_createTextVNode("Our Services")
      ]),
      /*#__PURE__*/_createElementVNode("span", null, [
        /*#__PURE__*/_createElementVNode("i", {
          class: "fa fa-circle",
          "aria-hidden": "true"
        }),
        /*#__PURE__*/_createTextVNode("Prescription Refills")
      ]),
      /*#__PURE__*/_createElementVNode("span", null, [
        /*#__PURE__*/_createElementVNode("i", {
          class: "fa fa-circle",
          "aria-hidden": "true"
        }),
        /*#__PURE__*/_createTextVNode("Drug Delivery")
      ]),
      /*#__PURE__*/_createElementVNode("span", null, [
        /*#__PURE__*/_createElementVNode("i", {
          class: "fa fa-circle",
          "aria-hidden": "true"
        }),
        /*#__PURE__*/_createTextVNode("Consultations")
      ]),
      /*#__PURE__*/_createElementVNode("span", null, [
        /*#__PURE__*/_createElementVNode("i", {
          class: "fa fa-circle",
          "aria-hidden": "true"
        }),
        /*#__PURE__*/_createTextVNode("Medical Supplies")
      ]),
      /*#__PURE__*/_createElementVNode("span", null, [
        /*#__PURE__*/_createElementVNode("i", {
          class: "fa fa-circle",
          "aria-hidden": "true"
        }),
        /*#__PURE__*/_createTextVNode("Prescription Refills")
      ]),
      /*#__PURE__*/_createElementVNode("span", null, [
        /*#__PURE__*/_createElementVNode("i", {
          class: "fa fa-circle",
          "aria-hidden": "true"
        }),
        /*#__PURE__*/_createTextVNode("Drug Delivery")
      ]),
      /*#__PURE__*/_createElementVNode("span", null, [
        /*#__PURE__*/_createElementVNode("i", {
          class: "fa fa-circle",
          "aria-hidden": "true"
        }),
        /*#__PURE__*/_createTextVNode("Consultations")
      ])
    ])
  ])
], -1))
const _hoisted_110 = { class: "container" }
const _hoisted_111 = { class: "row" }
const _hoisted_112 = {
  id: "column-left",
  class: "col-sm-4 col-md-4 col-lg-3"
}
const _hoisted_113 = {
  class: "collapse navbar-collapse justify-content-end hidden-sm-down show",
  id: "category-menu"
}
const _hoisted_114 = {
  class: "navbar-nav align-self-end flex-wrap",
  id: "nav"
}
const _hoisted_115 = ["href"]
const _hoisted_116 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", { class: "nav-item" }, [
  /*#__PURE__*/_createElementVNode("a", {
    class: "nav-link",
    href: "/brands"
  }, "Top Brands")
], -1))
const _hoisted_117 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "left_banner left-sidebar-widget mt_30 mb_50 desktop-view" }, [
  /*#__PURE__*/_createElementVNode("a", { href: "#" }, [
    /*#__PURE__*/_createElementVNode("img", {
      src: "images/left1.jpg",
      alt: "Left Banner",
      class: "img-fluid"
    })
  ])
], -1))
const _hoisted_118 = {
  key: 0,
  class: "filter left-sidebar-widget mb_50 desktop-view"
}
const _hoisted_119 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "heading-part mtb_20" }, [
  /*#__PURE__*/_createElementVNode("h2", { class: "main_title" }, "Refined Search")
], -1))
const _hoisted_120 = { class: "filter-block" }
const _hoisted_121 = { class: "list-group" }
const _hoisted_122 = {
  key: 0,
  class: "list-group-item mb_10"
}
const _hoisted_123 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Categories", -1))
const _hoisted_124 = { id: "filter-group0" }
const _hoisted_125 = ["value"]
const _hoisted_126 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "amount" }, "Price range:", -1))
const _hoisted_127 = { class: "mtb_20" }
const _hoisted_128 = { class: "list-group" }
const _hoisted_129 = {
  key: 0,
  class: "list-group-item mb_10"
}
const _hoisted_130 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Color", -1))
const _hoisted_131 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { id: "filter-group0" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "checkbox" }, [
    /*#__PURE__*/_createElementVNode("label", null, [
      /*#__PURE__*/_createElementVNode("input", {
        value: "",
        type: "checkbox"
      }),
      /*#__PURE__*/_createTextVNode(" Red (10)")
    ])
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "checkbox" }, [
    /*#__PURE__*/_createElementVNode("label", null, [
      /*#__PURE__*/_createElementVNode("input", {
        value: "",
        type: "checkbox"
      }),
      /*#__PURE__*/_createTextVNode(" Green (06)")
    ])
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "checkbox" }, [
    /*#__PURE__*/_createElementVNode("label", null, [
      /*#__PURE__*/_createElementVNode("input", {
        value: "",
        type: "checkbox"
      }),
      /*#__PURE__*/_createTextVNode(" Blue(09) ")
    ])
  ])
], -1))
const _hoisted_132 = [
  _hoisted_130,
  _hoisted_131
]
const _hoisted_133 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "list-group-item mb_10" }, [
  /*#__PURE__*/_createElementVNode("label", null, "Color"),
  /*#__PURE__*/_createElementVNode("div", { id: "filter-group1" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "checkbox" }, [
      /*#__PURE__*/_createElementVNode("label", null, [
        /*#__PURE__*/_createElementVNode("input", {
          value: "",
          type: "checkbox"
        }),
        /*#__PURE__*/_createTextVNode(" Red (10)")
      ])
    ]),
    /*#__PURE__*/_createElementVNode("div", { class: "checkbox" }, [
      /*#__PURE__*/_createElementVNode("label", null, [
        /*#__PURE__*/_createElementVNode("input", {
          value: "",
          type: "checkbox"
        }),
        /*#__PURE__*/_createTextVNode(" Green (06)")
      ])
    ]),
    /*#__PURE__*/_createElementVNode("div", { class: "checkbox" }, [
      /*#__PURE__*/_createElementVNode("label", null, [
        /*#__PURE__*/_createElementVNode("input", {
          value: "",
          type: "checkbox"
        }),
        /*#__PURE__*/_createTextVNode(" Blue(09) ")
      ])
    ])
  ])
], -1))
const _hoisted_134 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "list-group-item mb_10" }, [
  /*#__PURE__*/_createElementVNode("label", null, "Size"),
  /*#__PURE__*/_createElementVNode("div", { id: "filter-group3" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "checkbox" }, [
      /*#__PURE__*/_createElementVNode("label", null, [
        /*#__PURE__*/_createElementVNode("input", {
          value: "",
          type: "checkbox"
        }),
        /*#__PURE__*/_createTextVNode(" Big (3)")
      ])
    ]),
    /*#__PURE__*/_createElementVNode("div", { class: "checkbox" }, [
      /*#__PURE__*/_createElementVNode("label", null, [
        /*#__PURE__*/_createElementVNode("input", {
          value: "",
          type: "checkbox"
        }),
        /*#__PURE__*/_createTextVNode(" Medium (2)")
      ])
    ]),
    /*#__PURE__*/_createElementVNode("div", { class: "checkbox" }, [
      /*#__PURE__*/_createElementVNode("label", null, [
        /*#__PURE__*/_createElementVNode("input", {
          value: "",
          type: "checkbox"
        }),
        /*#__PURE__*/_createTextVNode(" Small (1)")
      ])
    ])
  ])
], -1))
const _hoisted_135 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "btn"
}, "Refine Search", -1))
const _hoisted_136 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "left-cms left-sidebar-widget mb_50 desktop-view" }, [
  /*#__PURE__*/_createElementVNode("ul", null, [
    /*#__PURE__*/_createElementVNode("li", null, [
      /*#__PURE__*/_createElementVNode("div", { class: "feature-i-left ptb_20" }, [
        /*#__PURE__*/_createElementVNode("div", { class: "icon-right Shipping" }),
        /*#__PURE__*/_createElementVNode("h6", null, "Fast Shipping"),
        /*#__PURE__*/_createElementVNode("p", null, "Delivery countrywide")
      ])
    ]),
    /*#__PURE__*/_createElementVNode("li", null, [
      /*#__PURE__*/_createElementVNode("div", { class: "feature-i-left ptb_20" }, [
        /*#__PURE__*/_createElementVNode("div", { class: "icon-right Order" }),
        /*#__PURE__*/_createElementVNode("h6", null, "Order Online"),
        /*#__PURE__*/_createElementVNode("p", null, "Hours : 8am - 11pm")
      ])
    ]),
    /*#__PURE__*/_createElementVNode("li", null, [
      /*#__PURE__*/_createElementVNode("div", { class: "feature-i-left ptb_20" }, [
        /*#__PURE__*/_createElementVNode("div", { class: "icon-right Save" }),
        /*#__PURE__*/_createElementVNode("h6", null, "Shop And Save"),
        /*#__PURE__*/_createElementVNode("p", null, "For All Products")
      ])
    ]),
    /*#__PURE__*/_createElementVNode("li", null, [
      /*#__PURE__*/_createElementVNode("div", { class: "feature-i-left ptb_20" }, [
        /*#__PURE__*/_createElementVNode("div", { class: "icon-right Safe" }),
        /*#__PURE__*/_createElementVNode("h6", null, "Guarnteed Data Privacy"),
        /*#__PURE__*/_createElementVNode("p", null, "We Ensure 100% privacy")
      ])
    ])
  ])
], -1))
const _hoisted_137 = { class: "left-special left-sidebar-widget mb_50 desktop-view" }
const _hoisted_138 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "heading-part mb_20" }, [
  /*#__PURE__*/_createElementVNode("h2", { class: "main_title" }, "Top Products")
], -1))
const _hoisted_139 = {
  id: "left-special",
  class: "owl-carousel"
}
const _hoisted_140 = { class: "product-list col-4" }
const _hoisted_141 = { class: "product-thumb" }
const _hoisted_142 = { class: "image product-imageblock" }
const _hoisted_143 = ["href"]
const _hoisted_144 = ["title"]
const _hoisted_145 = ["title"]
const _hoisted_146 = ["href"]
const _hoisted_147 = ["src"]
const _hoisted_148 = { class: "col-8" }
const _hoisted_149 = { class: "caption product-detail" }
const _hoisted_150 = { class: "product-name ellipsis" }
const _hoisted_151 = ["href"]
const _hoisted_152 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "rating" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "fa fa-stack" }, [
    /*#__PURE__*/_createElementVNode("i", { class: "fa fa-star-o fa-stack-1x" }),
    /*#__PURE__*/_createElementVNode("i", { class: "fa fa-star fa-stack-1x" })
  ]),
  /*#__PURE__*/_createElementVNode("span", { class: "fa fa-stack" }, [
    /*#__PURE__*/_createElementVNode("i", { class: "fa fa-star-o fa-stack-1x" }),
    /*#__PURE__*/_createElementVNode("i", { class: "fa fa-star fa-stack-1x" })
  ]),
  /*#__PURE__*/_createElementVNode("span", { class: "fa fa-stack" }, [
    /*#__PURE__*/_createElementVNode("i", { class: "fa fa-star-o fa-stack-1x" }),
    /*#__PURE__*/_createElementVNode("i", { class: "fa fa-star fa-stack-1x" })
  ]),
  /*#__PURE__*/_createElementVNode("span", { class: "fa fa-stack" }, [
    /*#__PURE__*/_createElementVNode("i", { class: "fa fa-star-o fa-stack-1x" }),
    /*#__PURE__*/_createElementVNode("i", { class: "fa fa-star fa-stack-1x" })
  ]),
  /*#__PURE__*/_createElementVNode("span", { class: "fa fa-stack" }, [
    /*#__PURE__*/_createElementVNode("i", { class: "fa fa-star-o fa-stack-1x" }),
    /*#__PURE__*/_createElementVNode("i", { class: "fa fa-star fa-stack-x" })
  ])
], -1))
const _hoisted_153 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "price" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "amount" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "currencySymbol" }, "KES "),
    /*#__PURE__*/_createTextVNode(" 0.00 ")
  ])
], -1))
const _hoisted_154 = {
  id: "column-right",
  class: "col-sm-12 col-md-8 col-lg-9 mtb_30"
}
const _hoisted_155 = { class: "footer pt_60" }
const _hoisted_156 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "container" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "row" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "col-md-3 footer-block" }, [
      /*#__PURE__*/_createElementVNode("div", { class: "content_footercms_right" }, [
        /*#__PURE__*/_createElementVNode("div", { class: "footer-contact" }, [
          /*#__PURE__*/_createElementVNode("div", { class: "footer-logo mb_40" }, [
            /*#__PURE__*/_createElementVNode("a", { href: "/" }, [
              /*#__PURE__*/_createElementVNode("img", {
                src: "images/logo.png",
                alt: "AVA Pharmacy Ltd.",
                style: {"max-width":"164px"}
              })
            ])
          ]),
          /*#__PURE__*/_createElementVNode("ul", null, [
            /*#__PURE__*/_createElementVNode("li", null, "The hub, Karen Opposite Carrefour"),
            /*#__PURE__*/_createElementVNode("li", null, " 0715 737 330 - 0733 737 330"),
            /*#__PURE__*/_createElementVNode("li", null, "info@avapharmacy.co.ke")
          ]),
          /*#__PURE__*/_createElementVNode("div", { class: "social_icon" }, [
            /*#__PURE__*/_createElementVNode("ul", null, [
              /*#__PURE__*/_createElementVNode("li", null, [
                /*#__PURE__*/_createElementVNode("a", { href: "#" }, [
                  /*#__PURE__*/_createElementVNode("i", { class: "fa fa-facebook" })
                ])
              ]),
              /*#__PURE__*/_createElementVNode("li", null, [
                /*#__PURE__*/_createElementVNode("a", { href: "#" }, [
                  /*#__PURE__*/_createElementVNode("i", { class: "fa fa-google" })
                ])
              ]),
              /*#__PURE__*/_createElementVNode("li", null, [
                /*#__PURE__*/_createElementVNode("a", { href: "#" }, [
                  /*#__PURE__*/_createElementVNode("i", { class: "fa fa-linkedin" })
                ])
              ]),
              /*#__PURE__*/_createElementVNode("li", null, [
                /*#__PURE__*/_createElementVNode("a", { href: "#" }, [
                  /*#__PURE__*/_createElementVNode("i", { class: "fa fa-twitter" })
                ])
              ]),
              /*#__PURE__*/_createElementVNode("li", null, [
                /*#__PURE__*/_createElementVNode("a", { href: "#" }, [
                  /*#__PURE__*/_createElementVNode("i", { class: "fa fa-rss" })
                ])
              ])
            ])
          ])
        ])
      ])
    ]),
    /*#__PURE__*/_createElementVNode("div", { class: "col-md-3 footer-block" }, [
      /*#__PURE__*/_createElementVNode("h6", { class: "footer-title ptb_20" }, "Categories"),
      /*#__PURE__*/_createElementVNode("ul", null, [
        /*#__PURE__*/_createElementVNode("li", null, [
          /*#__PURE__*/_createElementVNode("a", { href: "#" }, "Medicines")
        ]),
        /*#__PURE__*/_createElementVNode("li", null, [
          /*#__PURE__*/_createElementVNode("a", { href: "#" }, "AVA Pharmacy Ltd.")
        ]),
        /*#__PURE__*/_createElementVNode("li", null, [
          /*#__PURE__*/_createElementVNode("a", { href: "#" }, "Mother & Baby")
        ]),
        /*#__PURE__*/_createElementVNode("li", null, [
          /*#__PURE__*/_createElementVNode("a", { href: "#" }, "Vitamins")
        ]),
        /*#__PURE__*/_createElementVNode("li", null, [
          /*#__PURE__*/_createElementVNode("a", { href: "#" }, "Toiletries")
        ]),
        /*#__PURE__*/_createElementVNode("li", null, [
          /*#__PURE__*/_createElementVNode("a", { href: "#" }, "Skincare")
        ])
      ])
    ]),
    /*#__PURE__*/_createElementVNode("div", { class: "col-md-3 footer-block" }, [
      /*#__PURE__*/_createElementVNode("h6", { class: "footer-title ptb_20" }, "Information"),
      /*#__PURE__*/_createElementVNode("ul", null, [
        /*#__PURE__*/_createElementVNode("li", null, [
          /*#__PURE__*/_createElementVNode("a", { href: "contact" }, "Specials")
        ]),
        /*#__PURE__*/_createElementVNode("li", null, [
          /*#__PURE__*/_createElementVNode("a", { href: "#" }, "New Products")
        ]),
        /*#__PURE__*/_createElementVNode("li", null, [
          /*#__PURE__*/_createElementVNode("a", { href: "#" }, "Best Sellers")
        ]),
        /*#__PURE__*/_createElementVNode("li", null, [
          /*#__PURE__*/_createElementVNode("a", { href: "#" }, "Our Stores")
        ]),
        /*#__PURE__*/_createElementVNode("li", null, [
          /*#__PURE__*/_createElementVNode("a", { href: "#" }, "Contact Us")
        ])
      ])
    ]),
    /*#__PURE__*/_createElementVNode("div", { class: "col-md-3 footer-block" }, [
      /*#__PURE__*/_createElementVNode("h6", { class: "footer-title ptb_20" }, "My Account"),
      /*#__PURE__*/_createElementVNode("ul", null, [
        /*#__PURE__*/_createElementVNode("li", null, [
          /*#__PURE__*/_createElementVNode("a", { href: "#" }, "Checkout")
        ]),
        /*#__PURE__*/_createElementVNode("li", null, [
          /*#__PURE__*/_createElementVNode("a", { href: "#" }, "My Account")
        ]),
        /*#__PURE__*/_createElementVNode("li", null, [
          /*#__PURE__*/_createElementVNode("a", { href: "#" }, "My Orders")
        ]),
        /*#__PURE__*/_createElementVNode("li", null, [
          /*#__PURE__*/_createElementVNode("a", { href: "#" }, "My Credit Slips")
        ]),
        /*#__PURE__*/_createElementVNode("li", null, [
          /*#__PURE__*/_createElementVNode("a", { href: "#" }, "My Addresses")
        ]),
        /*#__PURE__*/_createElementVNode("li", null, [
          /*#__PURE__*/_createElementVNode("a", { href: "#" }, "My Personal Info")
        ])
      ])
    ])
  ])
], -1))
const _hoisted_157 = { class: "footer-bottom mt_60 ptb_10" }
const _hoisted_158 = { class: "container" }
const _hoisted_159 = { class: "row" }
const _hoisted_160 = { class: "col-sm-6" }
const _hoisted_161 = { class: "copyright-part" }
const _hoisted_162 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-sm-6" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "payment-icon text-right" })
], -1))
const _hoisted_163 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", { id: "scrollup" }, "Scroll", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_title = _resolveComponent("ion-title")!
  const _component_ion_toolbar = _resolveComponent("ion-toolbar")!
  const _component_ion_header = _resolveComponent("ion-header")!
  const _component_ion_item = _resolveComponent("ion-item")!
  const _component_ion_label = _resolveComponent("ion-label")!
  const _component_ion_list = _resolveComponent("ion-list")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_menu = _resolveComponent("ion-menu")!
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_ion_menu_button = _resolveComponent("ion-menu-button")!
  const _component_ion_buttons = _resolveComponent("ion-buttons")!
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_ion_range = _resolveComponent("ion-range")!
  const _component_ion_router_outlet = _resolveComponent("ion-router-outlet")!
  const _component_ion_page = _resolveComponent("ion-page")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_ion_menu, {
      side: "start",
      "content-id": "main-content"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_ion_header, null, {
          default: _withCtx(() => [
            _createVNode(_component_ion_toolbar, { translucent: "" }, {
              default: _withCtx(() => [
                _createVNode(_component_ion_title, null, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.currentRouteName), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_ion_content, null, {
          default: _withCtx(() => [
            _createVNode(_component_ion_list, null, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.collections.filter(x => x.parent.name == '__root_collection__' && x.slug !='brands' && x.slug !='on-promotions').slice(0, 8), (collection) => {
                  return (_openBlock(), _createBlock(_component_ion_item, {
                    button: "",
                    key: collection.id
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("a", {
                        href: '/category/' + collection.slug
                      }, _toDisplayString(collection.name), 9, _hoisted_1)
                    ]),
                    _: 2
                  }, 1024))
                }), 128)),
                _createVNode(_component_ion_item, { class: "active" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_label, null, {
                      default: _withCtx(() => [
                        _hoisted_2
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createElementVNode("div", _hoisted_3, [
          _hoisted_4,
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("h3", null, "© " + _toDisplayString(_ctx.fullYear), 1)
          ])
        ])
      ]),
      _: 1
    }),
    _createVNode(_component_ion_page, { id: "main-content" }, {
      default: _withCtx(() => [
        _createVNode(_component_ion_content, {
          fullscreen: true,
          padding: "",
          class: "scrollbar-width-thin"
        }, {
          default: _withCtx(() => [
            _hoisted_6,
            _createElementVNode("div", _hoisted_7, [
              _hoisted_8,
              _createElementVNode("header", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("div", _hoisted_11, [
                    _createElementVNode("div", _hoisted_12, [
                      _hoisted_13,
                      _createElementVNode("div", _hoisted_14, [
                        _createElementVNode("ul", _hoisted_15, [
                          (!_ctx.activeCustomer)
                            ? (_openBlock(), _createElementBlock("li", _hoisted_16, _hoisted_18))
                            : (_ctx.activeCustomer)
                              ? (_openBlock(), _createElementBlock("li", _hoisted_19, [
                                  _createElementVNode("a", _hoisted_20, "Hello " + _toDisplayString(_ctx.activeCustomer.firstName), 1)
                                ]))
                              : _createCommentVNode("", true),
                          _hoisted_21
                        ])
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_22, [
                  _createElementVNode("div", _hoisted_23, [
                    _createElementVNode("nav", _hoisted_24, [
                      _hoisted_25,
                      _createElementVNode("div", _hoisted_26, [
                        _createElementVNode("ul", _hoisted_27, [
                          _hoisted_28,
                          _createElementVNode("li", _hoisted_29, [
                            _hoisted_30,
                            _createElementVNode("div", _hoisted_31, [
                              _hoisted_32,
                              _hoisted_33,
                              _hoisted_34,
                              _createElementVNode("div", _hoisted_35, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.collections.filter(x => x.parent.name == '__root_collection__' && x.slug !='brands' && x.slug !='on-promotions' && x.productVariants.items.length>2).slice(0, 5), (collection) => {
                                  return (_openBlock(), _createElementBlock("div", {
                                    key: collection.id
                                  }, [
                                    _createElementVNode("div", _hoisted_36, _toDisplayString(collection.name), 1),
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(collection.productVariants.items, (item, ix) => {
                                      return (_openBlock(), _createElementBlock("a", {
                                        key: ix,
                                        class: "dropdown-item",
                                        href: '/product/' + item.product.slug,
                                        title: item.name
                                      }, _toDisplayString(_ctx.$filters.titleCase(item.name.slice(0, 15)+'...')), 9, _hoisted_37))
                                    }), 128))
                                  ]))
                                }), 128))
                              ]),
                              _hoisted_38,
                              _createElementVNode("div", _hoisted_39, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.collections.filter(x => x.parent.name == '__root_collection__' && x.slug !='brands' && x.slug !='on-promotions' && x.productVariants.items.length>1).slice(5, 10), (collection) => {
                                  return (_openBlock(), _createElementBlock("div", {
                                    key: collection.id
                                  }, [
                                    _createElementVNode("div", _hoisted_40, _toDisplayString(collection.name), 1),
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(collection.productVariants.items, (item, ix) => {
                                      return (_openBlock(), _createElementBlock("a", {
                                        key: ix,
                                        class: "dropdown-item",
                                        href: '/product/' + item.product.slug,
                                        title: item.name
                                      }, _toDisplayString(_ctx.$filters.titleCase(item.name.slice(0, 15)+'...')), 9, _hoisted_41))
                                    }), 128))
                                  ]))
                                }), 128))
                              ]),
                              _hoisted_42,
                              _hoisted_43
                            ])
                          ]),
                          _createElementVNode("li", _hoisted_44, [
                            _hoisted_45,
                            _createElementVNode("div", _hoisted_46, [
                              _hoisted_47,
                              _hoisted_48,
                              _hoisted_49,
                              _createElementVNode("div", _hoisted_50, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.collections.filter(x => x.parent.name == 'Brands' && x.productVariants.items.length>2).slice(0, 5), (collection) => {
                                  return (_openBlock(), _createElementBlock("div", {
                                    key: collection.id
                                  }, [
                                    _createElementVNode("div", _hoisted_51, _toDisplayString(collection.name), 1),
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(collection.productVariants.items, (item, ix) => {
                                      return (_openBlock(), _createElementBlock("a", {
                                        key: ix,
                                        class: "dropdown-item",
                                        href: '/product/' + item.product.slug,
                                        title: item.name
                                      }, _toDisplayString(_ctx.$filters.titleCase(item.name.slice(0, 15)+'...')), 9, _hoisted_52))
                                    }), 128))
                                  ]))
                                }), 128))
                              ]),
                              _hoisted_53,
                              _createElementVNode("div", _hoisted_54, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.collections.filter(x => x.parent.name == 'Brands' && x.productVariants.items.length>2).slice(5, 10), (collection) => {
                                  return (_openBlock(), _createElementBlock("div", {
                                    key: collection.id
                                  }, [
                                    _createElementVNode("div", _hoisted_55, _toDisplayString(collection.name), 1),
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(collection.productVariants.items, (item, ix) => {
                                      return (_openBlock(), _createElementBlock("a", {
                                        key: ix,
                                        class: "dropdown-item",
                                        href: '/product/' + item.product.slug,
                                        title: item.name
                                      }, _toDisplayString(_ctx.$filters.titleCase(item.name.slice(0, 15)+'...')), 9, _hoisted_56))
                                    }), 128))
                                  ]))
                                }), 128))
                              ]),
                              _hoisted_57,
                              _hoisted_58
                            ])
                          ]),
                          _hoisted_59,
                          _createElementVNode("li", _hoisted_60, [
                            _createElementVNode("a", _hoisted_61, [
                              _createVNode(_component_ion_icon, { icon: _ctx.cloudUploadOutline }, null, 8, ["icon"]),
                              _hoisted_62
                            ])
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_63, [
                        _hoisted_64,
                        _createElementVNode("div", _hoisted_65, [
                          _createElementVNode("div", _hoisted_66, [
                            _hoisted_67,
                            _createTextVNode(_toDisplayString(_ctx.activeOrder?.lines?.length), 1)
                          ]),
                          _createElementVNode("div", _hoisted_68, [
                            (_ctx.activeOrder)
                              ? (_openBlock(), _createElementBlock("ul", _hoisted_69, [
                                  _createElementVNode("li", null, [
                                    _createElementVNode("table", _hoisted_70, [
                                      _createElementVNode("tbody", null, [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.activeOrder?.lines, (line) => {
                                          return (_openBlock(), _createElementBlock("tr", {
                                            key: line.id
                                          }, [
                                            _createElementVNode("td", _hoisted_71, [
                                              _createElementVNode("a", {
                                                href: 'product/'+line?.productVariant?.product?.slug
                                              }, [
                                                _createElementVNode("img", {
                                                  style: {"max-height":"84px"},
                                                  src: line.featuredAsset ==null ? 'images/default.png':line.featuredAsset?.source,
                                                  alt: line.productVariant.name,
                                                  title: line.productVariant.name
                                                }, null, 8, _hoisted_73)
                                              ], 8, _hoisted_72)
                                            ]),
                                            _createElementVNode("td", _hoisted_74, [
                                              _createElementVNode("a", _hoisted_75, _toDisplayString(_ctx.$filters.titleCase(line.productVariant.name)), 1),
                                              _createElementVNode("span", _hoisted_76, _toDisplayString(_ctx.activeOrder.currencyCode) + " " + _toDisplayString(_ctx.$filters.priceFormatting(line.linePriceWithTax)), 1),
                                              _createElementVNode("div", _hoisted_77, [
                                                _createElementVNode("div", _hoisted_78, [
                                                  _createElementVNode("span", {
                                                    class: "input-group-text",
                                                    onClick: ($event: any) => (_ctx.dec(line.quantity, line.id))
                                                  }, "-", 8, _hoisted_79)
                                                ]),
                                                _createElementVNode("input", {
                                                  type: "number",
                                                  class: "form-control cart-qty",
                                                  "aria-label": "Amount",
                                                  min: "1",
                                                  value: line.quantity,
                                                  onChange: ($event: any) => (_ctx.qntyChange($event,line.id))
                                                }, null, 40, _hoisted_80),
                                                _createElementVNode("div", _hoisted_81, [
                                                  _createElementVNode("span", {
                                                    class: "input-group-text",
                                                    onClick: ($event: any) => (_ctx.inc(line.quantity, line.id))
                                                  }, "+", 8, _hoisted_82)
                                                ])
                                              ])
                                            ]),
                                            _createElementVNode("td", _hoisted_83, [
                                              _createElementVNode("a", {
                                                class: "close-cart",
                                                onClick: ($event: any) => (_ctx.removeOrderLine(line.id))
                                              }, _hoisted_86, 8, _hoisted_84)
                                            ])
                                          ]))
                                        }), 128))
                                      ])
                                    ])
                                  ]),
                                  _createElementVNode("li", null, [
                                    _createElementVNode("table", _hoisted_87, [
                                      _createElementVNode("tbody", null, [
                                        _createElementVNode("tr", null, [
                                          _hoisted_88,
                                          _createElementVNode("td", _hoisted_89, "   " + _toDisplayString(_ctx.activeOrder.currencyCode) + _toDisplayString(_ctx.$filters.priceFormatting(_ctx.activeOrder.subTotal)), 1)
                                        ]),
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.activeOrder.taxSummary, (tax) => {
                                          return (_openBlock(), _createElementBlock("tr", {
                                            key: tax.description
                                          }, [
                                            _createElementVNode("td", _hoisted_90, [
                                              _createElementVNode("strong", null, _toDisplayString(tax.description) + " (" + _toDisplayString(tax.taxRate) + "%)", 1)
                                            ]),
                                            _createElementVNode("td", _hoisted_91, "   " + _toDisplayString(_ctx.activeOrder.currencyCode) + _toDisplayString(_ctx.$filters.priceFormatting(tax.taxTotal)), 1)
                                          ]))
                                        }), 128)),
                                        _createElementVNode("tr", null, [
                                          _hoisted_92,
                                          _createElementVNode("td", _hoisted_93, "   " + _toDisplayString(_ctx.activeOrder.currencyCode) + _toDisplayString(_ctx.$filters.priceFormatting(_ctx.activeOrder.totalWithTax)), 1)
                                        ])
                                      ])
                                    ])
                                  ]),
                                  _hoisted_94
                                ]))
                              : _createCommentVNode("", true)
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_95, [
                          _createElementVNode("div", _hoisted_96, [
                            _createElementVNode("a", {
                              href: "javascript:void(0)",
                              class: "search-overlay-close",
                              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.closeSearch && _ctx.closeSearch(...args)))
                            }),
                            _hoisted_97
                          ]),
                          _createElementVNode("div", _hoisted_98, [
                            _createElementVNode("a", {
                              id: "search-overlay-btn",
                              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.openSearch && _ctx.openSearch(...args)))
                            })
                          ])
                        ])
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_99, [
                  _createElementVNode("div", _hoisted_100, [
                    _createElementVNode("div", _hoisted_101, [
                      _createElementVNode("div", _hoisted_102, [
                        _hoisted_103,
                        _createElementVNode("div", _hoisted_104, [
                          _createElementVNode("ul", _hoisted_105, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.collections.filter(x => x.parent.name == '__root_collection__' && x.slug !='brands' && x.slug !='on-promotions').slice(0, 9), (collection) => {
                              return (_openBlock(), _createElementBlock("li", {
                                key: collection.id
                              }, [
                                _createElementVNode("a", {
                                  class: "nav-link",
                                  href: '/category/' + collection.slug
                                }, _toDisplayString(collection.name), 9, _hoisted_106)
                              ]))
                            }), 128)),
                            _hoisted_107
                          ]),
                          _hoisted_108
                        ])
                      ]),
                      _hoisted_109
                    ])
                  ])
                ])
              ]),
              _createVNode(_component_ion_header, { class: "mobile-view" }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_toolbar, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_buttons, { slot: "start" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_menu_button)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_ion_title, null, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.currentRouteName), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_ion_buttons, { slot: "end" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_button, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_icon, { icon: _ctx.personOutline }, null, 8, ["icon"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_ion_button, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_icon, { icon: _ctx.cartOutline }, null, 8, ["icon"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_ion_button, { onClick: _ctx.openPopover }, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_icon, { icon: _ctx.ellipsisVerticalOutline }, null, 8, ["icon"])
                            ]),
                            _: 1
                          }, 8, ["onClick"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createElementVNode("div", _hoisted_110, [
                _createElementVNode("div", _hoisted_111, [
                  _createElementVNode("div", _hoisted_112, [
                    _createElementVNode("div", _hoisted_113, [
                      _createElementVNode("ul", _hoisted_114, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.collections.filter(x => x.parent.name == '__root_collection__' && x.slug !='brands' && x.slug !='on-promotions').slice(0, 9), (collection) => {
                          return (_openBlock(), _createElementBlock("li", {
                            class: "nav-item",
                            key: collection.id
                          }, [
                            _createElementVNode("a", {
                              class: "nav-link",
                              href: '/category/' + collection.slug
                            }, _toDisplayString(collection.name), 9, _hoisted_115)
                          ]))
                        }), 128)),
                        _hoisted_116
                      ])
                    ]),
                    _hoisted_117,
                    (_ctx.currentRouteName=='Category' || _ctx.currentRouteName=='Categories')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_118, [
                          _hoisted_119,
                          _createElementVNode("div", _hoisted_120, [
                            _createElementVNode("div", _hoisted_121, [
                              (_ctx.currentRouteName=='Categories')
                                ? (_openBlock(), _createElementBlock("div", _hoisted_122, [
                                    _hoisted_123,
                                    _createElementVNode("div", _hoisted_124, [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.collections.filter(x => x.parent.name == '__root_collection__' && x.slug !='brands' && x.slug !='on-promotions'), (collection) => {
                                        return (_openBlock(), _createElementBlock("div", {
                                          class: "checkbox",
                                          key: collection.id
                                        }, [
                                          _createElementVNode("label", null, [
                                            _createElementVNode("input", {
                                              value: collection.slug,
                                              type: "checkbox"
                                            }, null, 8, _hoisted_125),
                                            _createTextVNode(" " + _toDisplayString(collection.name) + " (" + _toDisplayString(collection.productVariants.totalItems) + ")", 1)
                                          ])
                                        ]))
                                      }), 128))
                                    ])
                                  ]))
                                : _createCommentVNode("", true)
                            ]),
                            _createElementVNode("p", null, [
                              _hoisted_126,
                              _withDirectives(_createElementVNode("input", {
                                type: "text",
                                id: "amount",
                                readonly: "",
                                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.amountTextRange) = $event))
                              }, null, 512), [
                                [_vModelText, _ctx.amountTextRange]
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_127, [
                              _createVNode(_component_ion_range, {
                                ref: "rangeDualKnobs",
                                "dual-knobs": "true",
                                min: _ctx.priceWithTaxMin,
                                max: _ctx.priceWithTaxMax,
                                step: "50",
                                pin: "true",
                                onIonChange: _cache[3] || (_cache[3] = ($event: any) => (_ctx.priceRangeChange($event)))
                              }, null, 8, ["min", "max"])
                            ]),
                            _createElementVNode("div", _hoisted_128, [
                              (_ctx.currentRouteName=='Categories' || _ctx.currentRouteName=='Categories')
                                ? (_openBlock(), _createElementBlock("div", _hoisted_129, _hoisted_132))
                                : _createCommentVNode("", true),
                              _hoisted_133,
                              _hoisted_134,
                              _hoisted_135
                            ])
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    _hoisted_136,
                    _createElementVNode("div", _hoisted_137, [
                      _hoisted_138,
                      _createElementVNode("div", _hoisted_139, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.topSellers, (group, i) => {
                          return (_openBlock(), _createElementBlock("ul", {
                            class: "row",
                            key: i
                          }, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(group, (top) => {
                              return (_openBlock(), _createElementBlock("li", {
                                class: "item product-layout-left mb_20",
                                key: top.id
                              }, [
                                _createElementVNode("div", _hoisted_140, [
                                  _createElementVNode("div", _hoisted_141, [
                                    _createElementVNode("div", _hoisted_142, [
                                      (top.assets?.length==0)
                                        ? (_openBlock(), _createElementBlock("a", {
                                            key: 0,
                                            href: 'product/'+top.slug
                                          }, [
                                            _createElementVNode("img", {
                                              class: "img-thumbnail",
                                              title: _ctx.$filters.titleCase(top.name),
                                              src: "images/product/default.png"
                                            }, null, 8, _hoisted_144),
                                            _createElementVNode("img", {
                                              class: "img-thumbnail",
                                              title: _ctx.$filters.titleCase(top.name),
                                              src: "images/product/default.png"
                                            }, null, 8, _hoisted_145)
                                          ], 8, _hoisted_143))
                                        : _createCommentVNode("", true),
                                      (top.assets?.length>0)
                                        ? (_openBlock(), _createElementBlock("a", {
                                            key: 1,
                                            href: 'product/'+top.slug
                                          }, [
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(top.assets, (asset, idx) => {
                                              return (_openBlock(), _createElementBlock("img", {
                                                key: idx,
                                                class: "img-thumbnail",
                                                src: asset.source+'?w=90&h=90&mode=resize'
                                              }, null, 8, _hoisted_147))
                                            }), 128))
                                          ], 8, _hoisted_146))
                                        : _createCommentVNode("", true)
                                    ])
                                  ])
                                ]),
                                _createElementVNode("div", _hoisted_148, [
                                  _createElementVNode("div", _hoisted_149, [
                                    _createElementVNode("h6", _hoisted_150, [
                                      _createElementVNode("a", {
                                        href: 'product/'+top.slug
                                      }, _toDisplayString(_ctx.$filters.titleCase(top.name)), 9, _hoisted_151)
                                    ]),
                                    _hoisted_152,
                                    _hoisted_153
                                  ])
                                ])
                              ]))
                            }), 128))
                          ]))
                        }), 128))
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_154, [
                    (_openBlock(), _createBlock(_component_ion_router_outlet, {
                      style: {"position":"relative"},
                      key: _ctx.$route.fullPath
                    }))
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_155, [
                _hoisted_156,
                _createElementVNode("div", _hoisted_157, [
                  _createElementVNode("div", _hoisted_158, [
                    _createElementVNode("div", _hoisted_159, [
                      _createElementVNode("div", _hoisted_160, [
                        _createElementVNode("div", _hoisted_161, " Copyright © " + _toDisplayString(_ctx.fullYear) + " All Rights Reserved AVA Pharmacy Ltd.", 1)
                      ]),
                      _hoisted_162
                    ])
                  ])
                ])
              ]),
              _hoisted_163
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ], 64))
}